<div class="home-page-container">
  <div class="app-gutters list-page-gutters">  
    <div>
      <ng-container>
        <dxo-card [bodyHeader]="selectStateBodyHeader">
          <card-body>
            <div class="state">
              <dxo-dropdown                  
                data-e2e="state-dropdown"            
                label="State"
                (valueChange)="onFilterChange($any($event))"
                [optionsObjects]="statesDropdown"
              >
              </dxo-dropdown>
            </div>          
          </card-body>
        </dxo-card>
      </ng-container>   
    </div>  
    <div class="loader-container" *ngIf="isLoading">
      <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
    </div> 
    <div *ngIf="showEnrollment">
      <ng-container>
        <dxo-card [bodyHeader]="enrollmentBodyHeader" data-e2e="enrollment-body-header">
          <card-body>
              <div>
                <dxo-table
                  [stickyColumn]="false"
                  [data]="enrollmentDataTable"
                ></dxo-table>
              </div>          
          </card-body>
        </dxo-card>
      </ng-container>
    </div>

    <div *ngIf="showEOI">
      <ng-container>
        <dxo-card [bodyHeader]="eoiBodyHeader" data-e2e="eoi-body-header">
          <card-body>
              <div>
                <dxo-table
                  [stickyColumn]="false"
                  [data]="eoiDataTable"
                ></dxo-table>
              </div>          
          </card-body>
        </dxo-card>
      </ng-container>
    </div>

    <div *ngIf="showWaiver">
      <ng-container>
        <dxo-card [bodyHeader]="waiverBodyHeader" data-e2e="waiver-body-header">
          <card-body>
              <div>
                <dxo-table
                  [stickyColumn]="false"
                  [data]="waiverDataTable"
                ></dxo-table>
              </div>          
          </card-body>
        </dxo-card>
      </ng-container>
    </div>

    <div *ngIf="showConversion">
      <ng-container>
        <dxo-card [bodyHeader]="conversionBodyHeader" data-e2e="conversion-body-header">
          <card-body>
              <div>
                <dxo-table
                  [stickyColumn]="false"
                  [data]="conversionDataTable"
                ></dxo-table>
              </div>          
          </card-body>
        </dxo-card>
      </ng-container>
    </div>

    <div *ngIf="showPortability">
      <ng-container>
        <dxo-card [bodyHeader]="portabilityBodyHeader" data-e2e="portability-body-header">
          <card-body>
              <div>
                <dxo-table
                  [stickyColumn]="false"
                  [data]="portabilityDataTable"
                ></dxo-table>
              </div>          
          </card-body>
        </dxo-card>
      </ng-container>
    </div>
  </div>
</div>
